import { createSlice } from '@reduxjs/toolkit';
import ApiClient, { createFetchErrorMessage } from 'utils/api/ApiClient';


const initialState = {
  testIndex: 0,
  questionIndex: 0,
  answers1: [],
  answers2: [],
  message: null,
  complete: false,
  type: null,
  loading: true, testList: []
};
const readingTestSlice = createSlice({
  name: "reading/test",
  initialState,
  reducers: {
    loading: (state) => {
      return { ...initialState, loading: true };
    },
    fetch: (state, action) => {
      return { ...state, ...action.payload, loading: false };
    },
    error: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    pushAnswer: (state, action) => {
      if (state.type === 'TEST3') {
        if (state.testIndex === 0 && state.answers1.length < 30) {
          state = { ...state, answers1: state.answers1.concat(action.payload) };
        } else if (state.answers2.length < 15) {
          state = { ...state, answers2: [...state.answers2, action.payload] };
        }
      } else if (state.type === 'TEST2' && state.answers2.length < 15) {
        state = { ...state, answers2: [...state.answers2, action.payload] };
      } else if (state.type === 'TEST1' && state.answers1.length < 30) {
        state = { ...state, answers1: state.answers1.concat(action.payload) };
      }

      // 질문의 번호를 증가
      if (state.questionIndex >= (state.testList[state.testIndex].questions.length - 1)) {
        if (state.type === 'TEST3' && state.testIndex === 0) {
          // 종합이면 2단계 진입
          state = { ...state, testIndex: 1, questionIndex: 0 };
        } else {
          state = { ...state, complete: true };
        }
      } else {
        state = { ...state, questionIndex: state.questionIndex + 1 };
      }

      return state;
    },
    popAnswer: (state, action) => {
      if (state.type === 'TEST3') {
        if (state.testIndex === 0) {
          state = { ...state, answers1: state.answers1.slice(0, state.answers1.length - 1), questionIndex: state.questionIndex - 1 };
        } else {
          // 심화 진단 중이라면
          if (state.questionIndex === 0) {
            // 기본 진단으로 전환
            let questionIndex = state.answers1.length;
            state = { ...state, testIndex: 0, answers1: state.answers1.slice(0, state.answers1.length - 1), questionIndex: questionIndex - 1 };
          } else {
            state = { ...state, answers2: state.answers2.slice(0, state.answers2.length - 1), questionIndex: state.questionIndex - 1 };
          }
        }
      } else if (state.type === 'TEST2') {
        state = { ...state, answers2: state.answers2.slice(0, state.answers2.length - 1), questionIndex: state.questionIndex - 1 };
      } else if (state.type === 'TEST1') {
        state = { ...state, answers1: state.answers1.slice(0, state.answers1.length - 1), questionIndex: state.questionIndex - 1 };
      }

      return state;
    },
  },
});


export default readingTestSlice.reducer;
export const action = readingTestSlice.actions;


export const fetchReadingTest = (type) => {
  return (dispatch) => {
    dispatch(action.loading());

    const { promise } = ApiClient({
      method: "GET",
      url: `/api/reading/test/new/${type}`,
      authToken: sessionStorage.getItem("user"),
    });

    promise.then((res) => {
      dispatch(action.fetch({ testList: res.data, type }));
    }).catch((err) => {
      const errorData = createFetchErrorMessage(err);
      dispatch(action.error(errorData.message));
    });
  };
};


export const storeReadingTest = (postData) => {
  return (dispatch) => {
    const { promise } = ApiClient({
      url: "/api/reading/test/store",
      data: postData,
      authToken: sessionStorage.getItem("user"),
    });

    return promise;
  };
};


export const clearTest = () => {
  return (dispatch) => {
    dispatch(action.loading());
  };
};

export const pushAnswer = (answer) => {
  return (dispatch) => {
    dispatch(action.pushAnswer(answer));
  }
}
export const popAnswer = () => {
  return (dispatch) => {
    dispatch(action.popAnswer());
  }
};